import { render, staticRenderFns } from "./announce_conc.vue?vue&type=template&id=a4a80c2a&scoped=true&"
import script from "./announce_conc.vue?vue&type=script&lang=js&"
export * from "./announce_conc.vue?vue&type=script&lang=js&"
import style0 from "./announce_conc.vue?vue&type=style&index=0&id=a4a80c2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a80c2a",
  null
  
)

export default component.exports